import { Configure, Index, useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import NoResults from "./NoResults";
import { PageCardSkeleton } from "./PageCardSkeleton";
import { PageCard } from "./PageCard";
import { Page, PageHit } from "../page";
import { useIndexName } from "./IndexNameProvider";
import { searchIndexes } from "../../search-shared/client";
import { VirtualSearchBox } from "../../search-shared/VirtualSearchBox";

function PageHitsContent() {
    const { status } = useInstantSearch();
    const { items } = useHits<Page>();

    const onSelect = (hit: PageHit) => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/pages/${hit.handle}`;
    }

    return (
        <div className="tw-grid tw-auto-rows-fr tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-5">
            {(status === "loading" || status === "stalled") &&
                Array(6).fill(null).map((_, index) => <PageCardSkeleton key={index} />)
            }
            {(status === "idle") && items.length > 0 ?
                items.map((item) => {
                    return (
                        <PageCard key={item.objectID} onSelect={onSelect} pageHit={item} layout="vertical"/>
                    )
                }) : <NoResults />}
        </div>
    )
}

export default function PageHits() {
    const { pages_autocomplete_hits_per_page = 6 } = window.algoliaShopify.config;
    const { indexName: currentIndex } = useIndexName();
    const { query } = useSearchBox();

    return (
        <Index indexName={searchIndexes.PAGES}>
            <VirtualSearchBox />
                <Configure
                    hitsPerPage={pages_autocomplete_hits_per_page}
                    query={query}
                />

            {currentIndex === searchIndexes.PAGES &&
                <PageHitsContent />
            }
        </Index>
    )
}